import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { FaEye, FaHeart, FaTimesCircle, FaArrowLeft, FaCheck, FaLightbulb, FaArrowRight, FaArrowCircleLeft, FaArrowCircleRight, FaChevronUp, FaChevronDown, FaEdit } from 'react-icons/fa';
import { BsStopwatch } from 'react-icons/bs';
import Navbar from '../../dashboard/navbar';
import { useLocation, useNavigate } from 'react-router-dom';
import Sidebar from '../../dashboard/sidebar';
import useAuth from '../../dashboard/useAuth';
import axios from 'axios';
import QuestionModal from '../../administration/qcm/editeur_qcm';

const Demarrer = () => {
    useAuth(); // Vérifier l'authentification
    const location = useLocation();

    const [qcms, setQcms] = useState([]);
    const [qcmsFavoris, setQcmsFavoris] = useState([]);
    const [showInfo, setShowInfo] = useState(false);
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [answers, setAnswers] = useState({});
    const user_id = localStorage.getItem('user_id');
    const { simulation_id } = location.state || {};
    const navigate = useNavigate();

    const [currentQcmIndex, setCurrentQcmIndex] = useState(0);
    const [selectedAnswer, setSelectedAnswer] = useState(null);
    const [explanationVisible, setExplanationVisible] = useState(false);
    const [feedbackVisible, setFeedbackVisible] = useState(false);
    const [isAnswerCorrect, setIsAnswerCorrect] = useState(null);
    const [favorites, setFavorites] = useState(new Set());
    const [isLoading, setIsLoading] = useState(false);
    const [isButtonLoading, setIsButtonLoading] = useState(false);


    const [textColor, setTextColor] = useState('#000000');
    const [bgColor, setBgColor] = useState('#ffffff');
    const [optionColors, setOptionColors] = useState({});
    const [showColorPicker, setShowColorPicker] = useState(false);


    const [showModal, setShowModal] = useState(false);

    const handleCloseModal = () => {
        setShowModal(false);
    };



    // Utilisation de useEffect pour mettre à jour le titre de la page
    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Demarrer";
        }
    }, [user_id]);

    const handleFinishSimulation = async () => {
        // Logique de terminaison de simulation
        setIsButtonLoading(false)
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/enregistrer-reponses-qcm/${user_id}/${simulation_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    answers: answers
                }),
            });
            const response2 = await fetch(`${process.env.REACT_APP_HOTE}/pourcentage/${user_id}/${simulation_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            if (!response2.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            if (response.ok) {
                localStorage.removeItem('answers');
                localStorage.removeItem('currentQcmIndex');
                localStorage.removeItem('initialTimer');
                localStorage.removeItem('DebutTimer');
                navigate(`/Terminer`, {
                    state: { simulation_id: simulation_id },
                });
            } else {
                console.error('Erreur lors de l\'enregistrement des réponses');
                navigate(`/Terminer`, {
                    state: { simulation_id: simulation_id },
                });
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        } finally {
            setIsButtonLoading(false)
        }
    };

    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        // setTimeout(() => {
        //     setAlert({ message: '', type: '' });
        // }, 5000);
    };

    useEffect(() => {
        // Sauvegarde de l'index actuel à chaque changement
        if (qcms.length > 0) {
            localStorage.setItem('currentQcmIndex', currentQcmIndex);
        }
    }, [currentQcmIndex, qcms]);

    const handleDemarrer = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/demarrer-simulation/${user_id}/${simulation_id}/`);
            if (response.ok) {
                fetchSimulations()
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };


    const fetchSimulations = async () => {
        setIsLoading(true)
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/recuperer-qcms/${user_id}/${simulation_id}/`);
            if (response.ok) {
                const data = await response.json();
                setQcms(data.qcms);
                setIsLoading(false)


                // Récupérer l'index sauvegardé seulement après le chargement des QCMs
                const savedStep = localStorage.getItem('currentQcmIndex');
                if (savedStep) {
                    const step = Number(savedStep);
                    // S'assurer que l'index sauvegardé est valide
                    if (step >= 0 && step < data.qcms.length) {
                        setCurrentQcmIndex(step);
                    } else {
                        setCurrentQcmIndex(0); // Revenir au premier QCM si l'index est invalide
                    }
                }
            } else {
                console.error('Erreur lors de la récupération des simulations');
                setIsLoading(false)
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    useEffect(() => {

        fetchSimulations();
    }, [user_id, simulation_id]);




    // Ajout du minuteur
    const [timeLeft, setTimeLeft] = useState(0);
    const [timerActive, setTimerActive] = useState(true);
    const [simulationId, setSimulationId] = useState(null);

    // Modifiez votre useEffect pour le minuteur

    useEffect(() => {
        if (qcms.length > 0 && simulation_id) {
            // Récupérer l'ID réel de la simulation
            const simId = simulation_id.id || simulation_id;

            const initialTimer = qcms.length * 60; // 1 minute par question (en secondes)
            const savedSimulationId = localStorage.getItem('simulation_id');

            // Vérifier si c'est la même simulation
            if (savedSimulationId && savedSimulationId === String(simId)) {
                const savedDebutTimer = localStorage.getItem('DebutTimer');
                const savedInitialTimer = localStorage.getItem('initialTimer');

                if (savedDebutTimer && savedInitialTimer) {
                    const elapsedSeconds = Math.floor((Date.now() - parseInt(savedDebutTimer)) / 1000);
                    const remainingTime = Math.max(0, parseInt(savedInitialTimer) - elapsedSeconds);
                    setTimeLeft(Math.floor(remainingTime));
                } else {
                    // Nouvelle instance de la même simulation
                    setTimeLeft(initialTimer);
                    localStorage.setItem('initialTimer', initialTimer.toString());
                    localStorage.setItem('DebutTimer', Date.now().toString());
                }
            } else {
                // Nouvelle simulation
                localStorage.removeItem('initialTimer');
                localStorage.removeItem('DebutTimer');
                setTimeLeft(initialTimer);
                localStorage.setItem('initialTimer', initialTimer.toString());
                localStorage.setItem('DebutTimer', Date.now().toString());
                localStorage.setItem('simulation_id', String(simId));
            }

            setSimulationId(simId);
        }
    }, [qcms, simulation_id]);


    // Gérer le compte à rebours
    useEffect(() => {
        let timer;

        if (timerActive && timeLeft > 0) {
            timer = setInterval(() => {
                setTimeLeft(prevTime => {
                    const newTime = prevTime - 1;

                    // Ajoutez cette condition directement dans le setter
                    if (newTime <= 0) {
                        clearInterval(timer);
                        handleFinishSimulation();
                        return 0;
                    }
                    return newTime;
                });
            }, 1000);
        }

        return () => {
            if (timer) clearInterval(timer);
        };
    }, [timerActive, timeLeft]);


    useEffect(() => {
        const handleBeforeUnload = () => {
            // Sauvegarder l'état actuel sans nettoyer
            if (timerActive && timeLeft > 0 && simulationId) {
                localStorage.setItem('simulation_id', simulationId);
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [timerActive, timeLeft, simulationId]);


    // Formater le temps en minutes:secondes
    const formatTime = (seconds) => {
        const hours = Math.floor(seconds / 3600);
        const mins = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;

        if (hours > 0) {
            return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
        } else {
            return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
        }
    };





    useEffect(() => {
        const savedAnswers = localStorage.getItem('answers');
        if (savedAnswers) {
            setAnswers(JSON.parse(savedAnswers));
        }
    }, []);

    const handleAnswerChange = (qcmId, selectedValue) => {
        setSelectedAnswer({ qcmId, value: selectedValue });
        setExplanationVisible(false);
        setFeedbackVisible(false);
        setIsAnswerCorrect(null);

        setAnswers((prevAnswers) => {
            const updatedAnswers = { ...prevAnswers, [qcmId]: selectedValue };
            localStorage.setItem('answers', JSON.stringify(updatedAnswers));
            return updatedAnswers;
        });
    };

    const handleNextQcm = () => {
        if (currentQcmIndex < qcms.length - 1) {
            setCurrentQcmIndex(currentQcmIndex + 1);
            setExplanationVisible(false);
            setFeedbackVisible(false); // Réinitialiser la visibilité des feedbacks
            setIsAnswerCorrect(null);
            setAlert({ message: '', type: '' });
        }
    };

    const handlePreviousQcm = () => {
        if (currentQcmIndex > 0) {
            setCurrentQcmIndex(currentQcmIndex - 1);
            setExplanationVisible(false);
            setFeedbackVisible(false); // Réinitialiser la visibilité des feedbacks
            setIsAnswerCorrect(null); // Réinitialiser l'état de la réponse correcte
            setAlert({ message: '', type: '' });
        }
    };

    const handleShowExplanation = () => {
        setExplanationVisible(true);
    };

    // Nouvelle fonction pour vérifier la réponse
    const handleVerifierReponse = () => {
        const currentQcm = qcms[currentQcmIndex];
        const correctAnswers = currentQcm.reponse; // La réponse correcte est déjà un tableau
        const selectedAnswers = answers[currentQcm.id] || []; // Récupérer les réponses sélectionnées (tableau)

        if (selectedAnswers.length === 0) {
            showAlert('Choisissez au moins une réponse pour la vérifier.', 'danger');
        }
        // Vérifier si les réponses sélectionnées correspondent exactement aux réponses correctes
        const isAnswerCorrect =
            selectedAnswers.length === correctAnswers.length && // Vérifie que les longueurs sont identiques
            selectedAnswers.every((answer) => correctAnswers.includes(answer)) && // Chaque réponse sélectionnée est correcte
            correctAnswers.every((answer) => selectedAnswers.includes(answer)); // Chaque bonne réponse est sélectionnée

        if (isAnswerCorrect) {
            setIsAnswerCorrect(true); // La réponse est correcte
        } else {
            setIsAnswerCorrect(false); // La réponse est incorrecte
        }

        // Afficher le feedback et marquer la vérification comme faite
        setFeedbackVisible(true);
        setSelectedAnswer({
            qcmId: currentQcm.id,
            value: selectedAnswers,
        });

        // Optionnel: Log de feedback
        if (isAnswerCorrect) {
            console.log("Réponse correcte !");
        } else {
            console.log("Réponse incorrecte.");
        }
    };



    // const handleMultipleAnswerChange = (qcmId, option, isChecked) => {
    //     setAnswers(prevAnswers => {
    //         const currentAnswers = prevAnswers[qcmId] || []; // Récupérer les réponses actuelles pour ce QCM
    //         const updatedAnswers = isChecked
    //             ? [...currentAnswers, option] // Ajouter l'option si elle est cochée
    //             : currentAnswers.filter(answer => answer !== option); // Supprimer l'option si elle est décochée
    //         return {
    //             ...prevAnswers,
    //             [qcmId]: updatedAnswers, // Mettre à jour les réponses pour ce QCM
    //         };
    //     });
    // };


    const handleMultipleAnswerChange = (qcmId, option, isChecked) => {
        setAnswers(prevAnswers => {
            const isMultipleChoice = qcms.find(qcm => qcm.id === qcmId)?.reponse.length > 1; // Vérifier si plusieurs réponses sont possibles

            if (isMultipleChoice) {
                // Cas QCM à choix multiple : Ajouter ou retirer l'option cochée
                const currentAnswers = prevAnswers[qcmId] || [];
                const updatedAnswers = isChecked
                    ? [...currentAnswers, option] // Ajouter l'option si cochée
                    : currentAnswers.filter(answer => answer !== option); // Supprimer l'option si décochée
                return {
                    ...prevAnswers,
                    [qcmId]: updatedAnswers, // Mettre à jour uniquement la question concernée
                };
            } else {
                // Cas QCM à choix unique : Remplacer l'ancienne réponse par la nouvelle
                return {
                    ...prevAnswers,
                    [qcmId]: isChecked ? [option] : [], // Stocke uniquement la dernière option sélectionnée
                };
            }
        });
    };



    const fetchFavoris = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/liste-favoris/${user_id}/`);
            if (response.ok) {
                const data = await response.json();
                setQcmsFavoris(Array.isArray(data) ? data : [data]);
            }
        } catch (err) {
            console.error('Erreur réseau: ' + err.message);
        }
    };

    useEffect(() => {

        if (user_id) {
            fetchFavoris();
        }
    }, [user_id]);


    const handleFavoris = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/favoris-qcm/${user_id}/${simulation_id}/${qcms[currentQcmIndex]?.id}/`);
            if (response.ok) {
                console.error('Qcm ajouté aux favoris');
                // showAlert('Qcm ajouté aux favoris');
                fetchFavoris()
            } else {
                console.error('Erreur lors de l\'ajout de ce qcm aux favoris');
                showAlert('Ce Qcm existe déjà dans vos favoris');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }

        // const qcmId = qcms[currentQcmIndex].id;
        // const updatedFavorites = new Set(favorites);
        // if (updatedFavorites.has(qcmId)) {
        //     updatedFavorites.delete(qcmId);
        // } else {
        //     updatedFavorites.add(qcmId);
        // }
        // setFavorites(updatedFavorites);
        // fetchFavoris();
    };


    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("Simulation")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <div className='row align-items-end'>
                                <h2>
                                    <BsStopwatch size={25} className='mr-2' />Simulateur
                                </h2>
                                <span
                                    className="ml-3 toggle-icon"
                                    style={{ cursor: 'pointer', marginBottom: '10px' }}
                                    onClick={() => setShowInfo(!showInfo)}
                                >
                                    {showInfo ? <FaChevronUp /> : <FaChevronDown />}
                                </span>
                                <div className="row timer ml-3">
                                    <span>{formatTime(timeLeft)}</span>
                                </div>
                            </div>

                            <div className={`info-box ${showInfo ? "open" : ""}`}>
                                <small>
                                    Pour chaque QCM, une seule réponse est possible. Cochez la bonne réponse. Utilisez les boutons pour une meilleure gestion des QCM.
                                    <br />
                                    <b>Légende des icônes : </b>
                                    <FaEye className="ivt-align-menu" /> indique que la question a été déjà vue.
                                    <FaHeart className="ivt-align-menu" /> indique que la question est mise en favoris; dans ce cas cliquez sur le menu Simulateur &gt; Favoris.
                                    <br />
                                    Le bouton <FaTimesCircle className="ivt-align-menu" /> permet de terminer une simulation.
                                    Le bouton <FaArrowLeft className="ivt-align-menu" /> permet d'aller sur la question précédente.
                                    Le bouton <FaCheck className="ivt-align-menu" /> permet de vérifier si la réponse choisie est correcte.
                                    Le bouton <FaLightbulb className="ivt-align-menu" /> permet d'afficher le corrigé type d'une question.
                                    Le bouton <FaHeart className="ivt-align-menu" /> permet de mettre une question en favoris.
                                    Le bouton <FaArrowRight className="ivt-align-menu" /> permet d'aller sur la question suivante.
                                </small>
                            </div>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Historique-complet`}> Simulateur </Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        {simulation_id}
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`mt-3 alert alert-${alert.type}`}>
                            {alert.message}
                        </div>
                    )}

                    <div className="wrapper wrapper-content animated fadeInRight mt-3">
                        <div className="row d-flex justify-content-center">
                            <div className="col-lg-8 mx-auto">
                                <div className="ibox">
                                    <div className="ibox-title pr-3">
                                        <tr className='d-flex justify-content-between align-items-center'>
                                            <div className='d-flex'>
                                                <td className='badge badge-secondary'> {qcms[currentQcmIndex]?.ref} </td>
                                                <td>
                                                    {qcms[currentQcmIndex]?.deja_vu === "oui" && (
                                                        <i className="ml-1 fa fa-eye" title="Déjà vu"></i>
                                                    )}
                                                </td>
                                                <td>
                                                    {qcms[currentQcmIndex]?.id && qcmsFavoris.some(fav => fav.id === qcms[currentQcmIndex].id) && (
                                                        <i className="ml-1 fa fa-heart text-red-500" title="Favoris"></i>
                                                    )}
                                                </td>
                                            </div>
                                            <td>
                                                {qcms.length > 0 ? `${currentQcmIndex + 1} sur ${qcms.length}` : "0 sur 0"}
                                            </td>

                                            <td className='d-flex'>
                                                <button
                                                    className="btn btn-outline btn-secondary btn-sm mr-2"
                                                    onClick={() => setShowColorPicker(!showColorPicker)}
                                                    title="Personnaliser les couleurs"
                                                >
                                                    <i className="fa fa-paint-brush"></i>
                                                </button>

                                                {showColorPicker && (
                                                    <div className="color-palette" style={{
                                                        position: 'absolute',
                                                        top: '100%',
                                                        right: '10',
                                                        zIndex: 1000,
                                                        backgroundColor: 'white',
                                                        border: '1px solid #ddd',
                                                        borderRadius: '5px',
                                                        padding: '10px',
                                                        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                                                        width: '250px'
                                                    }}>
                                                        <div className="mb-2">
                                                            <label className="small">Couleur du texte:</label>
                                                            <input
                                                                type="color"
                                                                className="form-control form-control-color"
                                                                value={textColor}
                                                                onChange={(e) => setTextColor(e.target.value)}
                                                                style={{ width: '100%', height: '40px' }}
                                                            />
                                                        </div>

                                                        <div className="mb-2">
                                                            <label className="small">Couleur de fond:</label>
                                                            <input
                                                                type="color"
                                                                className="form-control form-control-color"
                                                                value={bgColor}
                                                                onChange={(e) => setBgColor(e.target.value)}
                                                                style={{ width: '100%', height: '40px' }}
                                                            />
                                                        </div>

                                                        <div className="mt-2 text-right">
                                                            <button
                                                                className="btn btn-sm btn-secondary mr-2"
                                                                onClick={() => {
                                                                    setShowColorPicker(false);
                                                                }}
                                                            >
                                                                Fermer
                                                            </button>
                                                            <button
                                                                className="btn btn-sm btn-secondary"
                                                                onClick={() => {
                                                                    setTextColor('#000000');
                                                                    setBgColor('#ffffff');
                                                                    setOptionColors({});
                                                                }}
                                                            >
                                                                Réinitialiser
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}

                                                <div className="mr-2 d-flex">
                                                    <Button
                                                        className="btn btn-outline btn-secondary btn-sm"
                                                        onClick={() => {
                                                            const elements = document.querySelectorAll('.ibox-content, .ibox-content *');
                                                            elements.forEach(element => {
                                                                const currentSize = parseInt(window.getComputedStyle(element).fontSize);
                                                                element.style.fontSize = `${currentSize + 1}px`;
                                                            });
                                                        }}
                                                        title="Zoomer"
                                                    >
                                                        <i className="fa fa-search-plus"></i>
                                                    </Button>
                                                    <Button
                                                        className="btn btn-outline btn-secondary btn-sm ml-1"
                                                        onClick={() => {
                                                            const elements = document.querySelectorAll('.ibox-content, .ibox-content *');
                                                            elements.forEach(element => {
                                                                const currentSize = parseInt(window.getComputedStyle(element).fontSize);
                                                                element.style.fontSize = `${Math.max(12, currentSize - 1)}px`;
                                                            });
                                                        }}
                                                        title="Dézoomer"
                                                    >
                                                        <i className="fa fa-search-minus"></i>
                                                    </Button>
                                                </div>
                                                {accesGroupe.includes("Administration") &&
                                                    <Button className='mr-2' onClick={() => setShowModal(true)}>
                                                        <FaEdit />
                                                        {showModal && currentQcmIndex !== null && (
                                                            <QuestionModal
                                                                show={showModal}
                                                                handleClose={handleCloseModal}
                                                                qcm_ref={qcms[currentQcmIndex]?.unicite}
                                                                user_id={user_id}
                                                                reussite={handleDemarrer}
                                                            />
                                                        )}
                                                    </Button>
                                                }
                                                {isButtonLoading ? (
                                                    <button className="btn btn-success mr-2" disabled>
                                                        <i className="fa fa-spinner fa-spin mr-1"></i>
                                                        <span className="d-none d-sm-inline ml-2">
                                                            Chargement...
                                                        </span>
                                                    </button>
                                                ) : (
                                                    <button className="btn btn-outline btn-warning" onClick={handleFinishSimulation} disabled={isButtonLoading}>
                                                        <i className="fa fa-times-circle mr-1"></i>
                                                        <span className="d-none d-sm-inline">
                                                            {isButtonLoading ? "Chargement" : "Terminer la simulation"}
                                                        </span>
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                    </div>
                                    {!isLoading ? (
                                        <div className="ibox-content" style={{
                                            backgroundColor: bgColor,
                                            transition: 'all 0.3s ease'
                                        }}>
                                            {qcms.length > 0 ? (
                                                <form>
                                                    <input type="hidden" name="qcmidhidden" id="qcmidhidden" value={qcms[currentQcmIndex]?.id} />
                                                    <div
                                                        id="question"
                                                        style={{
                                                            fontSize: '12px',
                                                            color: textColor
                                                        }}
                                                        dangerouslySetInnerHTML={{ __html: qcms[currentQcmIndex]?.question }}
                                                    ></div>

                                                    <div style={{ margin: '10px 10px' }}>
                                                        {Object.keys(qcms[currentQcmIndex])
                                                            .filter(key => key.startsWith('option') && qcms[currentQcmIndex][key] && (qcms[currentQcmIndex][key] !== 'non défini' && qcms[currentQcmIndex][key] !== 'vide')) // Filtrer les options non définies ou nulles
                                                            .map((key, index) => {
                                                                const optionLetter = String.fromCharCode(65 + index); // Convertir l'index en lettre (A, B, C, ...)
                                                                const isMultipleChoice = qcms[currentQcmIndex].reponse.length > 1; // Vérifie si plusieurs réponses
                                                                const currentAnswers = answers[qcms[currentQcmIndex].id] || [];
                                                                const isOptionChecked = currentAnswers.includes(optionLetter);
                                                                const optionColor = optionColors[optionLetter] || textColor;
                                                                return (
                                                                    <div className="checkbox" key={key} style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        marginBottom: '10px',
                                                                        backgroundColor: isOptionChecked ? 'rgba(0,123,255,0.1)' : 'transparent',
                                                                        padding: '5px',
                                                                        borderRadius: '5px'
                                                                    }}>
                                                                        <label style={{
                                                                            margin: 0,
                                                                            fontSize: '12px',
                                                                            cursor: 'pointer',
                                                                            color: optionColor,
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            width: '100%'
                                                                        }}>
                                                                            <input
                                                                                type={isMultipleChoice ? "checkbox" : "radio"}
                                                                                name={`qcmitem-${qcms[currentQcmIndex].id}`}
                                                                                value={optionLetter}
                                                                                className="i-checks choix"
                                                                                style={{ marginRight: '10px', cursor: 'pointer' }}
                                                                                onChange={(e) => handleMultipleAnswerChange(qcms[currentQcmIndex].id, optionLetter, e.target.checked)}
                                                                                checked={isOptionChecked}
                                                                            />
                                                                            {optionLetter} - <span id={`option${index + 1}`}>{qcms[currentQcmIndex][key]}</span>

                                                                            {feedbackVisible &&
                                                                                selectedAnswer?.qcmId === qcms[currentQcmIndex].id &&
                                                                                selectedAnswer.value.includes(optionLetter) &&
                                                                                !explanationVisible && (
                                                                                    qcms[currentQcmIndex].reponse.includes(optionLetter) ? (
                                                                                        <i className="fa fa-thumbs-o-up fa-2x ivt-align-menu" style={{ color: 'green', marginLeft: '5px' }} title="Correct"></i>
                                                                                    ) : (
                                                                                        <i className="fa fa-thumbs-o-down fa-2x ivt-align-menu" style={{ color: 'red', marginLeft: '5px' }} title="Incorrect"></i>
                                                                                    )
                                                                                )}

                                                                            {explanationVisible &&
                                                                                qcms[currentQcmIndex].reponse.includes(optionLetter) && (
                                                                                    <i className="fa fa-thumbs-o-up fa-2x ivt-align-menu" style={{ color: 'green', marginLeft: '5px' }} title="Correct Answer"></i>
                                                                                )}
                                                                        </label>
                                                                    </div>
                                                                );
                                                            })}
                                                    </div>


                                                    {explanationVisible && qcms[currentQcmIndex].explication != 'non défini' && (
                                                        <div className='d-flex' style={{ color: 'green' }}>
                                                            <div style={{ color: 'green' }}>
                                                                <span>Explication : </span>
                                                                <span dangerouslySetInnerHTML={{ __html: qcms[currentQcmIndex].explication }} />
                                                            </div>
                                                        </div>
                                                    )}
                                                </form>
                                            ) : (
                                                <p>Aucun QCM trouvé.</p>
                                            )}
                                        </div>
                                    ) : (

                                        <div className="mt-3 d-flex justify-content-center align-items-center" style={{ height: '100%', width: '100%' }}>
                                            <span
                                                className="spinner-border spinner-border-lg text-success"
                                                role="status"
                                                aria-hidden="true"
                                                style={{ width: '3rem', height: '3rem' }}
                                            ></span>
                                        </div>
                                    )}
                                    <div className="ibox-footer d-flex justify-content-end flex-wrap gap-2">
                                        <div className="ml-1">
                                            <Button
                                                onClick={handleFavoris}
                                                className="btn btn-outline btn-info"
                                            >
                                                <FaHeart className="me-1 mr-1" />
                                                <span className='labelInfo1'>Favoris</span>
                                            </Button>
                                        </div>

                                        <div className="ml-1">
                                            <Button
                                                onClick={handleVerifierReponse}
                                                className="btn btn-outline btn-info"
                                            >
                                                <FaCheck className="me-1 mr-1" />
                                                <span className='labelInfo1'>Vérifier</span>
                                            </Button>
                                        </div>

                                        <div className="ml-1">
                                            <Button
                                                onClick={handleShowExplanation}
                                                className="btn btn-outline btn-primary "
                                            >
                                                <FaLightbulb className="me-1 mr-1" />
                                                <span className='labelInfo1'>Corrigé</span>
                                            </Button>
                                        </div>

                                        <div className="ml-1">
                                            <Button
                                                onClick={handlePreviousQcm}
                                                style={{ display: currentQcmIndex === 0 ? 'none' : 'block' }}
                                                className="btn btn-outline btn-success"
                                            >
                                                <FaArrowCircleLeft className="me-1 mr-1" />
                                                <span className='labelInfo1'>Précédent</span>
                                            </Button>
                                        </div>
                                        <div className="ml-1">
                                            <Button
                                                onClick={handleNextQcm}
                                                style={{ display: currentQcmIndex === qcms.length - 1 ? 'none' : 'block' }}
                                                className="btn btn-outline btn-success"
                                            >
                                                <span className='labelInfo1'>Suivant</span>
                                                <FaArrowCircleRight className="me-1 ml-1" />
                                            </Button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    );
};



export default Demarrer;
